export default [
	{
		name: 'Name',
		field: 'name',
		width: 'large'
	},
	{
		name: 'Pin',
		field: 'pin_number',
		width: 'large'
	}
]



/** WEBPACK FOOTER **
 ** ./src/tables/cashiers.js
 **/